import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {
  Button,
  Modal,
  ToggleButton,
  ButtonGroup,
  Form,
  InputGroup,
} from "react-bootstrap";
import { fabric } from "fabric";
import { FabricJSCanvas, useFabricJSEditor } from "fabricjs-react";
import { Save } from "react-feather";
import useScreenSize from "../../hooks/useScreenSize";
import "./jobView.css";

import { ReactComponent as TagIcon } from "./../../assets/icons/tag.svg";
// import { ReactComponent as EditIcon } from "./../../assets/icons/edit.svg";
import { ReactComponent as CloseIcon } from "./../../assets/icons/close.svg";
import { ReactComponent as TIcon } from "./../../assets/icons/t.svg";
import { ReactComponent as DrawIcon } from "./../../assets/icons/draw.svg";
import { ReactComponent as SquareIcon } from "./../../assets/icons/square.svg";
import { ReactComponent as CircleIcon } from "./../../assets/icons/circle.svg";
import { ReactComponent as BasketIcon } from "./../../assets/icons/basket.svg";
import { ReactComponent as LeftArrow } from "./../../assets/icons/leftarrow.svg"
import { ReactComponent as RightArrow } from "./../../assets/icons/rightarrow.svg"
import LoadingWrapper from "../../components/LoadingWrapper";
import useKeyPress from "../../hooks/useKeyPressed";
import { truncate } from "lodash";

const deleteIcon = "data:image/png;base64,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";
// "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAAoklEQVRYhe2WMQrDMAxFX3qHmvb+R8kWOiXQQHoYZ1GgQ2NsWXY66K1G+g+MZIPjOH/OCLyAoKgNUjvWCExABJZCiSA1UXqouQOzNFqBp6LmUSNQKmEeXiLRLDxHonl4SqJb+C+JDXj3DP+WOIIj8NGG3wylBsNeSVJXkLMnzMKPO9csK7PwszNziZxRayZRMufmEpolYypx+XN8+YfEcZzm7McLWPPS8dTFAAAAAElFTkSuQmCC";

const deleteImg = document.createElement("img");
deleteImg.src = deleteIcon;

function deleteObject(_eventData, transform) {
  const target = transform.target;
  const canvas = target.canvas;
  canvas.remove(target);
  canvas.requestRenderAll();
}

const renderIcon = (icon) =>
  function renderIcon(ctx, left, top, _styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };

const deleteControl = new fabric.Control({
  x: 0.5,
  y: -0.5,
  offsetY: -16,
  offsetX: 16,
  cursorStyle: "pointer",
  mouseUpHandler: deleteObject,
  render: renderIcon(deleteImg),
  cornerSize: 18,
});

fabric.Object.prototype.controls.deleteControl = deleteControl;
if (fabric.Textbox) {
  fabric.Textbox.prototype.controls.deleteControl = deleteControl;
}

const colorRadios = [
  { color: "#000", value: "1" },
  { color: "#fff", value: "2" },
  { color: "#F1F36D", value: "3" },
  { color: "#2277DA", value: "4" },
  { color: "#D31010", value: "5" },
  { color: "#27BD48", value: "6" },
];

const radios = [
  { icon: <TIcon />, value: "1" },
  { icon: <DrawIcon />, value: "2" },
  { icon: <SquareIcon />, value: "3" },
  { icon: <CircleIcon />, value: "4" },
];

const Popup = (props) => {
  const leftKeyPressed = useKeyPress('ArrowLeft');
  const rightKeyPressed = useKeyPress('ArrowRight');

  const modalContentRef = useRef({ getDataURL() { }, getTags() { } });
  const { isMobile } = useScreenSize();
  const [editDescriptionMode, setEditDescriptionMode] = useState(false);
  const [description, setDescription] = useState()

  const handleImageSubmit = async () => {
    const dataUrl = modalContentRef.current.getDataURL();
    const tags = modalContentRef.current.getTags();
    await props.onSubmit(dataUrl, tags);
  };

  const updateDescriptionHandler = () => {
    props.onUpdateDescription(description);
    setEditDescriptionMode(false);
  }

  useEffect(() => {
    if (leftKeyPressed) {
      props.prev(true);
    }
    //console.log(leftKeyPressed)
  }, [leftKeyPressed]);

  useEffect(() => {
    if (rightKeyPressed) {
      props.next(true);
    }
    //console.log(leftKeyPressed)
  }, [rightKeyPressed]);

  useEffect(() => {
    setDescription(null);
    if (props.description) {
      setDescription(props.description);
    }
  }, [props.description])

  return (
    <>
      <Modal
        size={isMobile ? undefined : "md"}
        show={props.show}
        onHide={props.onHide}
        centered
      >
        <Modal.Header closeButton>
          {!editDescriptionMode ? (
            <div className="d-flex justify-content-between w-100">
              <div className="d-flex align-content-center">
                <p >{description ?? <i>No description</i>}</p>
              </div>
              <Button onClick={() => setEditDescriptionMode(!editDescriptionMode)}>Edit</Button>
            </div>
          ) : (
            <InputGroup
              className="rounded-pill me-2"
              size="md"
              style={{ height: 24 }}
            >
              <Form.Control
                maxLength={50}
                autoFocus
                placeholder="Enter description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <Button onClick={updateDescriptionHandler}>
                <Save size={20} />
              </Button>
            </InputGroup>
          )}
          {/* <div className="fs-5 text-brown font-weight-semibold">
            {modalContentRef.current?.getTags()}
          </div> */}
          {/* <Button className="d-flex align-items-center bg-brown">
              <EditIcon className="me-1" />
              <span className="modal-header-btn">Edit</span>
            </Button> */}
        </Modal.Header>
        <Modal.Body>
          <ModalContent ref={modalContentRef} {...props} />
          <div className="d-flex justify-content-evenly mt-3">
            <Button
              className="modal-delete-btn d-flex align-items-center"
              onClick={props.onDelete}
            >
              <BasketIcon className="me-2" />
              <span className="text-black font-weight-semibold">
                Delete Photo
              </span>
            </Button>
            <Button
              className="modal-delete-btn d-flex align-items-center ms-2"
              onClick={handleImageSubmit}
            >
              <Save color="#0E4542" size={20} />
              <span className="ms-1 text-black font-weight-semibold">
                Save Image
              </span>
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Popup;

const ModalContent = forwardRef(({ url, tags: initialTags = [], onTagsChange, prev, next, currentItemIndex, totalCount, allTags }, ref) => {
  const [radioValue, setRadioValue] = useState();
  const [colorRadioValue, setColorRadioValue] = useState("1");
  const [brushWidth, setBrushWidth] = useState(1);
  const [tags, setTags] = useState(initialTags);
  const [addTagMode, setAddTagMode] = useState(!tags.length);
  const [newTag, setNewTag] = useState("");

  const [imageLoaded, setImageLoaded] = useState(false);
  const { editor, onReady, selectedObjects } = useFabricJSEditor();
  const canvasInited = useRef(false);
  const canvasContainer = useRef();
  const [firstSelectedObject] = selectedObjects || [];
  const { width } = useScreenSize();

  useImperativeHandle(ref, () => ({
    getDataURL: () => editor.canvas.toDataURL({ format: "png", multiplier: 4 }),
    getTags: () => tags.join(", "),
  }));

  useEffect(() => {
    if (!firstSelectedObject?.stroke) {
      return;
    }
    const { value: colorId } =
      colorRadios.find((col) => col.color === firstSelectedObject.stroke) || {};
    setColorRadioValue(colorId || "1");
  }, [firstSelectedObject?.stroke]);

  useEffect(() => {
    if (!editor || canvasInited.current) {
      return;
    }

    canvasInited.current = true;
    fabric.Image.fromURL(
      url,
      function (img) {
        const containerWidth = canvasContainer.current?.offsetWidth || width - 56;
        const canvasNewWidth = Math.min(img.width, containerWidth);
        const canvasNewHeight = img.height * (canvasNewWidth / img.width);

        editor.canvas.setBackgroundImage(
          img,
          editor.canvas.renderAll.bind(editor.canvas),
          {
            scaleX: canvasNewWidth / img.width,
            scaleY: canvasNewHeight / img.height,
          }
        );

        editor.canvas.setWidth(canvasNewWidth);
        editor.canvas.setHeight(canvasNewHeight);
        setImageLoaded(true);
      },
      {
        crossOrigin: "anonymous",
      }
    );
  }, [editor]);

  const handleSketchButtonPress = (e) => {
    setRadioValue(e.target.value);
    const { color } =
      colorRadios.find((col) => col.value === colorRadioValue) || {};

    editor.canvas.isDrawingMode = false;
    switch (e.target.value) {
      case "1": {
        editor.addText("Text");
        break;
      }
      case "2": {
        editor.canvas.isDrawingMode = true;
        editor.canvas.freeDrawingBrush.color = color;
        editor.canvas.freeDrawingBrush.width = Number(brushWidth);
        break;
      }
      case "3": {
        editor.addRectangle();
        break;
      }
      case "4": {
        editor.addCircle();
        break;
      }
    }
    const allObjects = editor.canvas.getObjects();
    const current = allObjects[allObjects.length - 1];

    editor.canvas.setActiveObject(current);
    editor.setStrokeColor(color);
    
  };

  const handleSketchColorChange = (e) => {
    setColorRadioValue(e.target.value);
    const { color } =
      colorRadios.find((col) => col.value === e.target.value) || {};

    editor.setStrokeColor(color);
    editor.canvas.freeDrawingBrush.color = color;
  };

  const handleNewTagSave = () => {
    const newTags = [newTag, ...tags];
    setTags(newTags);
    setNewTag("");
    setAddTagMode(false);
    onTagsChange(newTags.join(","));
  };

  const handleSelectTag = (tag) => {
    const newTags = [tag];
    setTags(newTags)
    setNewTag('');
    setAddTagMode(false);
    onTagsChange(newTags.join(","));
  }

  const handleTagRemove = (index) => {
    const newTags = tags.filter((_, i) => index !== i);
    setTags(newTags);
    onTagsChange(newTags);
    if (newTags.length == 0) {
      setAddTagMode(true);
    }
  };

  return (
    <>
      <div className="mb-2">
        <div className="d-flex flex-wrap align-items-center">
          {addTagMode ? (
            <>
              <InputGroup
                className="rounded-pill me-2"
                size="sm"
                style={{ maxWidth: 160, height: 24 }}
              >
                <Form.Control
                  autoFocus
                  placeholder="Enter tag..."
                  value={newTag}
                  onChange={(e) => setNewTag(e.target.value)}
                />
                <Button onClick={handleNewTagSave}>
                  <Save size={20} />
                </Button>
              </InputGroup>
              {allTags &&
                allTags.map((tag, index) => (
                  <div
                    key={index}
                    className="d-flex mt-1"
                    onClick={(e) => handleSelectTag(tag)}
                  >
                    <div className="modal-tag d-flex align-items-center me-1">
                      <TagIcon fill="000000" width={10} className="me-1" />
                      <span className="fs-6 text-black">{tag}</span>
                    </div>
                  </div>
                ))}
            </>
          ) : (
            <></>
            // <Button
            //   className="add-tag-btn rounded-circle me-2"
            //   size="sm"
            //   onClick={() => setAddTagMode(true)}
            // >
            //   <Plus size={18} />
            // </Button>
          )}
          {tags.map((tag, index) => (
            <div key={index} className="d-flex mt-1">
              <div className="modal-tag d-flex align-items-center me-1">
                <TagIcon fill="000000" width={10} className="me-1" />
                <span className="fs-6 text-black">{tag}</span>
              </div>
              <Button
                className="remove-tag-btn d-flex align-items-center justify-content-center rounded-circle me-2"
                onClick={() => handleTagRemove(index)}
              >
                <CloseIcon width={9} fill="#B51111" />
              </Button>
            </div>
          ))}
        </div>
      </div>

      <div className="d-flex justify-content-center">
        <LoadingWrapper loading={!imageLoaded}>
          <div
            ref={canvasContainer}
            className="d-flex justify-content-center align-items-center"
          >
            <FabricJSCanvas
              style={{ display: imageLoaded ? "unset" : "none" }}
              onReady={onReady}
            />
          </div>
        </LoadingWrapper>
      </div>

      <div className="d-flex justify-content-evenly mb-1 mt-1">
        <button
          style={{ opacity: !imageLoaded || currentItemIndex == 0 ? 0.5 : 1 }}
          className="arrow-btn"
          onClick={() => prev()}
          disabled={!imageLoaded || currentItemIndex == 0}
        >
          <LeftArrow></LeftArrow>
        </button>
        <button
          style={{
            opacity:
              !imageLoaded || currentItemIndex + 1 === totalCount ? 0.5 : 1,
          }}
          className="arrow-btn"
          onClick={() => next()}
          disabled={!imageLoaded || currentItemIndex + 1 === totalCount}
        >
          <RightArrow></RightArrow>
        </button>
      </div>

      <div className="img-controls d-flex align-items-center">
        <div className="font-weight-semibold text-brown fs-5">Sketch</div>
        <ButtonGroup className="w-100">
          {radios.map((radio, idx) => (
            <ToggleButton
              key={idx}
              id={`radio-${idx}`}
              type="radio"
              variant="outline-primary"
              name="radio"
              value={radio.value}
              checked={radioValue === radio.value}
              onChange={handleSketchButtonPress}
            >
              {radio.icon}
            </ToggleButton>
          ))}
        </ButtonGroup>
      </div>
      <div className="d-flex justify-content-center">
        {radioValue === "1" ? (
          <Form.Control
            style={{ width: "60%" }}
            className="mt-3"
            placeholder="Type here..."
            defaultValue={firstSelectedObject?.text || ""}
            onChange={(e) => {
              const { value } = e.target;
              if (!firstSelectedObject) {
                const { color } =
                  colorRadios.find((col) => col.value === colorRadioValue) ||
                  {};

                editor.addText(value);
                const allObjects = editor.canvas.getObjects();
                const current = allObjects[allObjects.length - 1];

                editor.canvas.setActiveObject(current);
                editor.setStrokeColor(color);
                editor.canvas.renderAll();
              } else {
                firstSelectedObject.text = value;
                editor.canvas.renderAll();
              }
            }}
          />
        ) : radioValue === "2" ? null : // <Form.Control
          //   style={{ width: "60%" }}
          //   className="mt-3"
          //   type="range"
          //   value={brushWidth}
          //   onChange={(e) => {

          //     const { value } = e.target;
          //     console.log(value);
          //     editor.canvas.freeDrawingBrush.width = Number(value);
          //     setBrushWidth(value);
          //   }}
          //   min={1}
          //   max={50}
          // />
          null}
      </div>
      <div className="color-pallete mt-3">
        <ButtonGroup className="color-pallete-btns px-1">
          {colorRadios.map((radio, idx) => (
            <ToggleButton
              key={idx}
              id={`color-${idx}`}
              type="radio"
              name="color"
              value={radio.value}
              checked={colorRadioValue === radio.value}
              onChange={handleSketchColorChange}
            >
              <div
                style={{ backgroundColor: radio.color }}
                className="radio-color-btn"
              />
            </ToggleButton>
          ))}
        </ButtonGroup>
      </div>
    </>
  );
});
